import type { ContactNoteItem } from '@/api/lcCrm'

export interface ContactNoteDraft {
  content: string
  expectedVersion: number
  stale: boolean
}

export type ContactNoteEditAction =
  | { type: 'start'; note: Pick<ContactNoteItem, 'content' | 'version'> }
  | { type: 'change'; content: string }
  | { type: 'stale' }
  | { type: 'review'; latestVersion: number }
  | { type: 'finish' }

export function contactNoteEditReducer(draft: ContactNoteDraft | null, action: ContactNoteEditAction): ContactNoteDraft | null {
  if (action.type === 'start') return { content: action.note.content, expectedVersion: action.note.version, stale: false }
  if (action.type === 'finish') return null
  if (!draft) return null
  if (action.type === 'change') return { ...draft, content: action.content }
  if (action.type === 'stale') return { ...draft, stale: true }
  return { ...draft, expectedVersion: action.latestVersion, stale: false }
}

export function isValidContactNoteContent(content: string): boolean {
  const length = content.trim().length
  return length > 0 && length <= 10000
}
